var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 78,
    viewBox: "0 0 462 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.0213 56.0693H57.7725V24.8849V3.31364C57.7725 3.31364 169.97 0.5 233.984 0.5C299.895 0.5 412.596 3.31364 412.596 3.31364V24.8849V56.0693H379.946C379.946 56.0693 292.081 53.9591 233.984 54.1936C175.887 54.428 88.0213 56.0693 88.0213 56.0693Z",
    fill: "#FCC14A",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.506 74.264L412.59 55.9754V24.8848L456.005 28.4018L435.691 52.0833L461.979 77.8749L385.506 74.264Z",
    fill: "#EAB64A",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M385.517 74.2662L412.601 55.9775H385.517V74.2662Z",
    fill: "#C79D4A",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8664 74.3579L57.7736 56.0692V24.8848L6.39327 28.4018L33.8758 52.0833L0.0205078 77.8749L82.8664 74.3579Z",
    fill: "#EAB64A",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8662 74.358L57.7734 56.0693H82.8662V74.358Z",
    fill: "#C79D4A",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputBg);
export default __webpack_public_path__ + "static/media/input_bg.595a58f423244f9d5e99fdb71861850a.svg";
export { ForwardRef as ReactComponent };